import { AppForms, theme } from '@/config'
import { ChatUser } from '@packages/chat'
import { UserList, Text, TextInput, View, Avatar } from '@/components'
import { ModalPage, ModalPageProps } from '../modals/ModalPage'
import { WebInputFile } from '@codeleap/types'
import { StaticImageData } from 'next/image'
import { Channel } from 'stream-chat'
import { useChatPreviewAvatar } from '@/hooks'

export type GroupFormModalPageProps = Partial<ModalPageProps> & {
  membersShown?: boolean
  channel?: Channel
}

export function GroupFormModalPage({ membersShown = true, channel, ...props }: GroupFormModalPageProps) {
  const selectedMembers = AppForms.chatGroup.use(s => s.values.members || []) as ChatUser[]
  const file = AppForms.chatGroup.use(s => s.values.file || []) as WebInputFile
  const groupName = AppForms.chatGroup.use(s => s.values.name || '') as string
  const previewAvatar = useChatPreviewAvatar({ channel })

  function handleFileChange(file) {
    AppForms.chatGroup.fields.file.setValue(file)
  }

  return (
    <ModalPage
      title='New group'
      canGoBack
      {...props}
    >
      <View style={['padding:2', 'column']}>
        <Avatar
          debugName='profile:avatar'
          badgeIcon={'camera'}
          name={!!groupName?.length ? groupName?.toLocaleUpperCase() : ('Group')}
          firstNameOnly={false}
          style={['huge', 'margin:auto', 'marginBottom:1']}
          image={file?.preview as unknown as StaticImageData || previewAvatar}
          onChange={handleFileChange}
        />

        <TextInput
          {...AppForms.chatGroup.register('name')}
          placeholder={channel ? 'Add your group name' : 'Add your group name (optional)'}
          maxLength={25}
          style={['noError', groupName?.length > 24 ? {
            innerWrapper: { borderColor: theme.colors.fieldNegativeStrokeDefault },
            'innerWrapper:focus': { borderColor: theme.colors.fieldNegativeStrokeDefault },
          } : {}]}
        />

        {!!membersShown && (
          <UserList
            ListHeaderComponent={() => (
              <Text text={`Members (${selectedMembers.length})`} style={['c1', 'marginTop:1', 'color:textParagraph']} />
            )}
            data={selectedMembers}
            style={{
              wrapper: {
                maxHeight: '60vh',
                overflow: 'auto',
              },
            }}
          />
        )}
      </View>
    </ModalPage>
  )
}
